<template>
  <div>
    <header-index></header-index>
    <div class="body">
      <div class="title">
        <router-link class="router" to="gpt4-0">
          <div class="ts iconfont">&#xe774; IC_Edit图像编辑</div>
        </router-link>
        <router-link class="router" to="kontext_v1">
          <div class="ts iconfont">&#xe6f9; Kontext_图像编辑</div>
        </router-link>
        <router-link class="router" to="kontext_v2">
          <div class="ts iconfont">&#xeb7a; Kontext_V2_图像编辑</div>
        </router-link>
        <router-link class="router" to="editimage">
          <div class="ts iconfont">&#xe662; PS图像编辑</div>
        </router-link>
        <router-link class="router" to="labshow" v-show="false">
          <div class="ts iconfont">&#xe6f9; 模态测试</div>
        </router-link>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ImageEditIndex',
  data() {
    return {
    }
  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

@keyframes opacity {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.router-link-active {
  transition: all 0.5s;
  background-color: @morejoy;
  border-radius: @border_radius;
  // color: @font_white;
}

.router-link-active .ts {
  color: @font_white !important; // 强制覆盖
  background-color: @morejoy;
  border-radius: @border_radius;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

header {
  height: 95px;
  width: 2560px;
  padding: 10px 10px 10px 30px;
  font-family: "icomoon";
  font-size: 18px;
  border-bottom: 1px solid @basicselect;

  .title {
    display: flex;
    color: @font_black;
    align-items: center;

    div {
      width: 430px;
      height: 75px;
      display: flex;
      align-items: center;
      padding: 10px;

      img {
        width: 230px;
        object-fit: cover
      }
    }

    .none {
      width: 1915px;
    }

    .back {
      display: flex;
      justify-content: center;
      width: 160px;
      height: 63px;
      background-color: @morejoy;
      color: @font_white;
      border-radius: @border_radius;
      cursor: pointer;
      transition: all 0.5s;
      font-size: 21px;

      &:hover {
        scale: 1.05;
        transition: all 0.5s;
      }
    }
  }
}

.body {
  width: 100vw;
  height: calc(100vh - 95px);
  overflow-y: scroll;
  overflow-x: hidden;
  color: @font_white;
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  .title {
    display: flex;
    height: 90px;
    line-height: 76px;
    justify-content: center;
    padding: 10px 30px 10px 30px;

    .router {
      flex: 1;
      text-decoration: none;
      color: @font_gray;
    }

    div {
      flex: 1;
      font-size: 25px;
      text-align: center;
      cursor: pointer;
      border-radius: @border_radius;
      border: 2px solid transparent;

      &:hover {
        border: 2px dashed @morejoy;
        transition: all 0.5s;
      }
    }
  }
}
</style>
